module.exports = __webpack_public_path__ + "img/pay_line.71ef492f.png";